import React from 'react';

const Download = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill="#5F6978" fillRule="evenodd" d="M17.25 20c.208 0 .385-.073.531-.219.146-.146.219-.323.219-.531V9h-4.25c-.208 0-.385-.073-.531-.219-.146-.146-.219-.323-.219-.531V4H6.75c-.208 0-.385.073-.531.219-.146.146-.219.323-.219.531v14.5c0 .208.073.385.219.531.146.146.323.219.531.219h10.5zM18 8v-.188c0-.208-.073-.385-.219-.53L14.72 4.218c-.146-.146-.323-.219-.532-.219H14v4h4zm-6 10c-.146 0-.27-.052-.375-.156l-3-3c-.167-.146-.208-.323-.125-.532.083-.208.24-.312.469-.312H11v-2.5c0-.146.047-.266.14-.36.094-.093.214-.14.36-.14h1c.146 0 .266.047.36.14.093.094.14.214.14.36V14h2.031c.23 0 .386.104.469.312.083.209.042.386-.125.532l-3 3c-.104.104-.23.156-.375.156z"/>
  </svg>
);

export default Download;
